import { useEffect, useState } from 'react'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { useAansluitingValuelists } from '../../../valuelists/hooks/useAansluitingValuelists'
import { ContractinstellingenActiviteiten } from '../components/ContractinstellingenActiviteiten'
import { ContractinstellingenBijlagen } from '../components/ContractinstellingenBijlagen'
import { ContractinstellingenContracten } from '../components/ContractinstellingenContracten'
import { ContractinstellingenFilters } from '../components/ContractinstellingenFilters'
import { ContractinstellingenLabels } from '../components/ContractinstellingenLabels'
import { ContractinstellingenProjectbetrokkenen } from '../components/ContractinstellingenProjectbetrokkenen'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

type Tab =
  | 'Bijlagen'
  | 'Activiteiten'
  | 'Contractgebieden'
  | 'Projectbetrokkenen'
  | 'Labels'

export const Contractinstellingen = () => {
  const user = useAuthenticatedUser()
  const { canViewContracten } = user
  const {
    data: { combis },
  } = useAansluitingValuelists()

  const [filters, setFilters] = useState<ContractinstellingenSearchFilters>({
    combi: null,
  })

  const [tab, setTab] = useState<Tab>('Bijlagen')

  const handleChange = (_: React.SyntheticEvent, newValue: Tab) => {
    setTab(newValue)
  }

  useEffect(() => {
    if (combis.length === 1) {
      setFilters({ combi: combis[0] })
    }
  }, [combis])

  return (
    <Page
      title={['Contractinstellingen']}
      breadcrumbs={[
        { label: 'Aansluiting', href: '/home', tooltip: 'CAPO home' },
        { label: 'Contractinstellingen' },
      ]}
    >
      <PageSection
        id="contractinstellingen"
        heading="Contractinstellingen"
        subheading="Hier vindt u de instellingen per combi."
      />

      <Box sx={{ marginBottom: 4 }}>
        <ContractinstellingenFilters
          filters={filters}
          onChange={setFilters}
          options={{ combis }}
        />

        <Tabs value={tab} onChange={handleChange}>
          <Tab label="Bijlagen" value={'Bijlagen'} />

          <Tab label="Activiteiten" value={'Activiteiten'} />

          {canViewContracten && (
            <Tab label="Contractgebieden" value={'Contractgebieden'} />
          )}

          <Tab label="Projectbetrokkenen" value={'Projectbetrokkenen'} />

          <Tab label="Labels" value={'Labels'} />
        </Tabs>

        <Divider />
      </Box>

      {tab === 'Bijlagen' && <ContractinstellingenBijlagen filters={filters} />}

      {tab === 'Activiteiten' && (
        <ContractinstellingenActiviteiten filters={filters} />
      )}

      {canViewContracten && tab === 'Contractgebieden' && (
        <ContractinstellingenContracten filters={filters} />
      )}

      {tab === 'Projectbetrokkenen' && (
        <ContractinstellingenProjectbetrokkenen filters={filters} />
      )}

      {tab === 'Labels' && <ContractinstellingenLabels filters={filters} />}
    </Page>
  )
}
